import { Component, type ReactNode } from 'react';
import { type ConnectedProps, connect } from 'react-redux';

import type { RootState } from 'reducers/types';

import { getCurrentStepIndex, getPaymentSteps } from '../../selectors';

type ScrollToTopProps = ConnectedProps<typeof connector> & {
  children?: ReactNode;
};

class ScrollToTopComponent extends Component<ScrollToTopProps> {
  componentDidMount() {
    this.scroll();
  }

  shouldComponentUpdate(nextProps: ScrollToTopProps) {
    return (
      nextProps.stepIndex !== this.props.stepIndex ||
      nextProps.totalSteps !== this.props.totalSteps
    );
  }

  componentDidUpdate() {
    if (window.scrollY === 0) {
      return;
    }
    this.scroll();
  }

  scroll() {
    window.scrollTo(0, 0);
  }

  render() {
    return this.props.children;
  }
}

const mapStateToProps = (state: RootState) => ({
  stepIndex: getCurrentStepIndex(state),
  totalSteps: getPaymentSteps(state).length,
});

const connector = connect(mapStateToProps);
const ScrollToTop = connector(ScrollToTopComponent);

export { ScrollToTop };
